export default "__VITE_ASSET__252bae41__"